import React from "react";
// import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const experienceDetails = [
    {
      yearRange: "noviembre 2025 - actualidad",
      title: "Software & IA Engineer",
      place: "Hospital Universitario de Canarias",
      desc: `Desarrollo ABAP en SAP ECC 6.0 con IS-H / ISH-MED. Mantenimiento y desarrollo de nuevas funcionalidades, como nuevos documentos clínicos e integraciones SOAP & HL7. Desarrollo web HTML.
             Desarrollo e implementación de modelos de Inteligencia Artificial (principalmente aprendizaje profundo y redes neuronales)
             SAP 6.0 ECC Enhanced Pack 4 - IS_H 604 - ISH-MED 6.4`,
      img: "images/resume/logo-huc.jpg",
    },
    {
      yearRange: "junio 2024 - noviembre 2024 & marzo 2025 - julio 2025",
      title: "Software Engineer",
      place: "A1M Entertainment",
      desc: `Departamento de Ingeniería. Trabajando con fluidez tanto en el front-end (React, TypeScript y MUI) como en el back (Prisma, Node.js y GraphQL).
            Desarrollamos soluciones web escalables e implementamos mejoras en la plataforma (nuevos torneos, paneles de admin, Metabase, …) así como el despliegue de la infraestructura en AWS, con herramientas como ECS, Cloudfront, RDS, Lambda, SNS, SQS, S3 y EC2 entre otras.`,
      img: "images/resume/logo-a1m.png",
    },
    {
      yearRange: "2021 - 2023",
      title: "Desarrollador Full-Stack",
      place: "Liga Canaria de Esports",
      desc: "Desarrollo de proyectos web de la Liga Canaria de Esports HiperDino y Tenerife GG. Desarrollo mayoritariamente front-end usando tecnologías como React, GraphQL y MUI, siempre con TypeScript, pero también desarrollando back-end en Node.JS usando el ORM Prisma. Desarrollo de las webs de Liga Canaria de Esports, Simseries, Tenerife GG y Gamelab Tenerife.",
      img: "images/resume/logo-lces.png",
    },
    {
      yearRange: "2015 - 2020",
      title: "Project Manager",
      place: "Gaming Experience",
      desc: "Planificación y ejecución de proyectos tecnológicos, así como la coordinación de los equipos de trabajo. Algunos de los proyectos desarrollados fueron: TGX, Juegos Escolares Minecraft Education (JEME), Liga Canaria de Esports HiperDino (LCES) e Intel Rising e-Stars entre otros",
      img: "images/resume/logo-gx.png",
    },
    // {
    //   yearRange: "2011 - 2013",
    //   title: "Innova7",
    //   place: "Social Media Manager & Esports Especialist",
    //   desc: "Organizador de eventos tecnológicos como TLP Tenerife. Responsable de Social Media y gestión de Esports",
    //   img: "images/resume/logo-innova7.png",
    // },
  ];

  const educationDetails = [
    {
      yearRange: "2025 - 2026",
      title: "Máster Universitario en Inteligencia Artificial",
      place: "UNIR",
      desc: "Formación avanzada y práctica en machine learning, deep learning, procesamiento del lenguaje natural, visión por computador y desarrollo de soluciones basadas en IA. Incluye el Programa Superior Universitario (PSU) de IA generativa aplicada a entornos empresariales, abordando herramientas como modelos generativos y su despliegue.",
      img: "images/resume/logo-unir.jpg",
    },
    {
      yearRange: "2020 - 2025",
      title: "Grado en Ingeniería Informática",
      place: "Universidad VIU",
      desc: "Grado en Ingeniería Informática en la Universidad Internacional de Valencia con un 9 de nota media y 12 matrículas de honor. Mención en Tecnologías de la InformaciónPremio Extraordinario Fin de Carrera Capitanía General de Valencia como mejor expediente académico 2025 en la Escuela de Ingeniería y Arquitectura. Proyecto de Fin de Grado (TFG) - Proyecto full-stack con integración de un clasificador de IA generativa.",
      img: "images/resume/logo-viu.png",
    },
    {
      yearRange: "2020 - 2020",
      title: "Curso de Especialización en Python",
      place: "Escuela de Organización Industrial (EOI)",
      desc: "Curso de especialización en Python, con una duración de 355 horas. Desarrollo web con Django, testing TDD, desarrollo de apps de escritorio, videojuegos, machine learning, infraestructura y despliegue así como dispositivos IoT.",
      img: "images/resume/logo-eoi.jpeg",
    },
    {
      yearRange: "2013 - 2015",
      title: "Ciclo Superior en Administración y Finanzas",
      place: "IES Óscar Domínguez",
      desc: "Capacitado para la organización y realización de la administración y gestión de personal, las operaciones económico-financieras y la información y asesoramiento a clientes y usuarios.",
      img: "images/resume/logo-ies.png",
    },
  ];

  const skillExperienceByCompany = {
    "Hospital Universitario de Canarias": {
      periods: [
        { start: "2025-11-01", end: new Date().toISOString().split("T")[0] },
      ],
      skills: {
        "Deep Learning": 1.0,
      },
    },
    "A1M Entertainment": {
      periods: [
        { start: "2024-06-01", end: "2024-11-30" },
        { start: "2025-03-01", end: "2025-07-31" },
      ],
      skills: {
        React: 1.0,
        "TypeScript / JavaScript": 1.0,
        GraphQL: 1.0,
        "Node.js": 1.0,
        Prisma: 1.0,
        AWS: 1.0,
        "Generative AI Integration": 0.4,
      },
    },
    "Liga Canaria de Esports": {
      periods: [{ start: "2021-11-01", end: "2023-12-31" }],
      skills: {
        React: 1.0,
        "TypeScript / JavaScript": 1.0,
        GraphQL: 1.0,
        "Node.js": 0.5,
        Prisma: 0.5,
        AWS: 0,
      },
    },
    "Gaming Experience": {
      periods: [{ start: "2015-07-01", end: "2020-12-31" }],
      skills: {
        React: 0,
        "TypeScript / JavaScript": 0,
        GraphQL: 0,
        "Node.js": 0,
        Prisma: 0,
        AWS: 0,
      },
    },
  };

  const skills = [
    { name: "React" },
    { name: "TypeScript / JavaScript" },
    { name: "GraphQL" },
    { name: "Node.js" },
    { name: "Prisma" },
    { name: "AWS" },
    { name: "Generative AI Integration" },
    { name: "Deep Learning" },
  ];

  const calculateMonths = (skillName) => {
    const currentDate = new Date();
    let totalMonths = 0;

    const contributions = [];

    Object.entries(skillExperienceByCompany).forEach(
      ([companyName, company]) => {
        const skillPercentage = company.skills[skillName] || 0;
        let companyTotal = 0;

        if (skillPercentage > 0) {
          company.periods.forEach((period) => {
            const startDate = new Date(period.start);
            let endDate = new Date(period.end);
            if (endDate > currentDate) {
              endDate = currentDate;
            }
            const months =
              (endDate.getFullYear() - startDate.getFullYear()) * 12 +
              (endDate.getMonth() - startDate.getMonth()) +
              1;
            const effectiveMonths = months * skillPercentage;

            companyTotal += effectiveMonths;
            totalMonths += effectiveMonths;
          });

          if (companyTotal > 0) {
            contributions.push(
              `${companyName}: ${formatExperience(companyTotal)}`,
            );
          }
        }
      },
    );

    // console.log(
    //   `\n${skillName}: ${formatExperience(totalMonths)} ${
    //     contributions.length > 0 ? `(${contributions.join(" + ")})` : ""
    //   }`
    // );

    return Math.round(totalMonths);
  };

  const formatExperience = (months) => {
    const years = Math.floor(months / 12);
    const remainingMonths = Math.round(months % 12);

    const adjustedMonths = remainingMonths - 1;

    if (years === 0) {
      return adjustedMonths > 0
        ? `${adjustedMonths} ${adjustedMonths === 1 ? "mes" : "meses"}`
        : "0";
    } else {
      return `${years} ${years === 1 ? "año" : "años"}${
        adjustedMonths > 0
          ? ` y ${adjustedMonths} ${adjustedMonths === 1 ? "mes" : "meses"}`
          : ""
      }`;
    }
  };

  const maxExperienceMonths = Math.max(
    ...skills.map((skill) => calculateMonths(skill.name)),
  );

  const updatedSkills = skills.map((skill) => {
    const months = calculateMonths(skill.name);
    return {
      ...skill,
      monthsExperience: months,
      experience: formatExperience(months),
    };
  });

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resumen</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Un resumen de mi currículum
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          {/* My Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">Mi experiencia</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    {/* LOGO */}
                    <img
                      src={value.img}
                      alt="logo"
                      style={
                        window.innerWidth > 768
                          ? {
                              height: "60px",
                              width: "auto",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }
                          : {
                              height: "auto",
                              maxWidth: "80vw",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }
                      }
                    />
                    <p
                      className="text-muted"
                      style={{
                        minHeight:
                          window.innerWidth > 768 ? "180px" : "inherit",
                      }}
                    >
                      {value.desc}
                    </p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>

          {/* My Education */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">Mi educación</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    {/* LOGO */}
                    <img
                      src={value.img}
                      alt="logo"
                      style={
                        window.innerWidth > 768
                          ? {
                              height: "60px",
                              width: "auto",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }
                          : {
                              height: "auto",
                              maxWidth: "80vw",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }
                      }
                    />
                    <p
                      className="text-muted"
                      style={{
                        minHeight:
                          window.innerWidth > 768 ? "180px" : "inherit",
                      }}
                    >
                      {value.desc}
                    </p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* Mis habilidades */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">
          Mis habilidades
        </h2>
        <div className="row gx-5">
          {updatedSkills.length > 0 &&
            updatedSkills.map((skill, index) => (
              <div className="col-md-6 wow fadeInUp" key={index}>
                <p className="fw-500 text-start mb-2">
                  {skill.name}{" "}
                  <span className="float-end">{skill.experience}</span>
                </p>
                <div className="progress progress-sm mb-4">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width:
                        (skill.monthsExperience / maxExperienceMonths) * 100 +
                        "%",
                    }}
                    aria-valuenow={skill.monthsExperience}
                    aria-valuemin={0}
                    aria-valuemax={maxExperienceMonths}
                  />
                </div>
              </div>
            ))}
        </div>
        {/* <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download CV
          </a>
        </p> */}
      </div>
    </section>
  );
};

export default Resume;
